import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  none: defineAsyncComponent(() => import("/vercel/path0/layouts/none.vue").then(m => m.default || m))
}